import CiteShow from "../components/cite/Show";

export default [
  { name: 'Cite', path: '/cite', component: CiteShow,  }
]
